// class ClerkClient {
//   constructor(private readonly publishableKey: string) {
//     this.clerk = new Clerk(publishableKey);

import { Clerk } from '@clerk/clerk-js';

//   }

//   async load() {
//     await this.clerk.load();
//   }
// }
const PUBLISHABLE_KEY = process.env.CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error('Add your Clerk Publishable Key to the .env file');
}

const clerk = new Clerk(PUBLISHABLE_KEY);
await clerk.load();

export default clerk;
export { PUBLISHABLE_KEY };
